import React, { useState } from 'react';
import { FlatList, TouchableOpacity } from 'react-native';
import { Icons } from '../../Components';
import Colors from '../../constants/colors';
import type { SettingProps } from '../api/types';
import type { FocusPositionProps, MyPlayerProps, PlayerSettingProps } from '../../types';
import { ProfileApi } from '../api';
import { useColors } from '../../constants/useColors';
import { Button, Text, TextInput, View } from '../../Components/Themed';

type SettingsManagerProps = {
    title: string,
    description: string,
    onFocusPosition?:(data:FocusPositionProps) => void,
    player:MyPlayerProps,
    settings:SettingProps[],
    icon:any,
    player_settings: PlayerSettingProps[],
    onUpdatePlayerSetting:(ps:PlayerSettingProps) => void
}

const SettingsManager = ({ player, title, description, icon, settings, player_settings, onFocusPosition, onUpdatePlayerSetting }:SettingsManagerProps) => {
    const C = useColors();
    const [ draft_setting, setDraftSetting ] = useState<PlayerSettingProps>()

    const handleUpdateSetting = async(setting:SettingProps, option:string, status:'active'|'inactive', player_setting?:PlayerSettingProps) => {
        if(player_setting){ player_setting.status = status }
        else {
            player_setting = {
                player_setting_id:'',
                player_id: '',
                setting_id: setting.setting_id,
                selected_option: option,
                create_datetime: '', last_update_datetime: '',
                status
            }
        }
        player_setting = await ProfileApi.updatePlayerSetting(player_setting)
        setDraftSetting(undefined)
        onUpdatePlayerSetting(player_setting)
    }

    const renderPreferences = (data: { item:SettingProps, index:number }) => {
        const my_settings = player_settings.filter(ps => ps.setting_id == data.item.setting_id);
        const editing = data.item.setting_id == draft_setting?.setting_id ? true : false;
        let shown_setting = editing ? draft_setting : my_settings[0]
        const is_changed = shown_setting?.selected_option != my_settings[0]?.selected_option ? true : false
        let disabled = false
        if(data.item.setting == 'collar_pct' && player.type != 'premium'){ disabled = true }
        return (
            <View float style={{ margin:10 }}>
                <View transparent style={{ padding:10, borderBottomWidth:1, borderColor:Colors.shades.shade600 }}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{flex:1}} theme='h2'>{data.item.setting_label}</Text>
                        {disabled ?
                        <Text style={{ marginLeft:5 }} theme='description' color={C.text.gold}>PREMIUM ONLY</Text>
                        :<></>}
                    </View>
                    <Text style={{ marginTop:5 }} theme='description'>{data.item.setting_description}</Text>
                </View>
                <View transparent>
                    {data.item.option_type == 'number_input' ?
                    <View transparent>
                        <View transparent style={{flexDirection:'row', alignItems:'center', padding:10}}>
                            <Text style={{ flex:1 }} theme='h1'>My Setting</Text>
                            <View type='input'>
                                <TextInput
                                    style={{minWidth:75, textAlign:'center' }}
                                    editable={editing}
                                    onFocusPosition={onFocusPosition}
                                    value={shown_setting?.selected_option}
                                    onChangeText={(text) => {
                                        if(!draft_setting){ return }
                                        setDraftSetting({ ...draft_setting, selected_option: text })
                                    }}
                                />
                            </View>
                            {!editing ?
                            <Button
                                title='EDIT'
                                style={{ marginLeft:5, opacity:disabled?0.5:1 }}
                                disabled={disabled}
                                type='close'
                                onPress={() => setDraftSetting(my_settings[0])}
                            />
                            :
                            <Button
                                title='X'
                                style={{ marginLeft:5 }}
                                type='error'
                                onPress={() => setDraftSetting(undefined)}
                            />
                            }
                        </View>
                        {is_changed ?
                        <Button
                            title='SAVE'
                            title_color={Colors.shades.white}
                            type='success'
                            onPress={() => {
                                if(!shown_setting){ return }
                                handleUpdateSetting(data.item, shown_setting.selected_option, 'active', shown_setting)}
                            }
                        />
                        :<></>}
                    </View>
                    :data.item.option_type == 'select' ?
                    <View transparent nativeID='setting_options' style={{ padding:15, flexDirection:'row', justifyContent:'space-between' }}>
                    {data.item.setting_options.map(so => {
                        const my_setting = my_settings.find(ms => ms.selected_option == so)
                        return (
                            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }}
                            onPress={() => handleUpdateSetting(data.item, so, my_setting?.status == 'active' ? 'inactive' : 'active', my_setting)}>
                                <View style={{ height:20, width:20, justifyContent:'center', alignItems:'center', borderWidth:1, borderRadius:100, borderColor:C.text.action, backgroundColor:my_setting?.status == 'active' ? C.text.action : 'transparent' }}>
                                    {my_setting?.status == 'active' ?
                                    <Icons.CheckIcon color={C.text.h1} size={10} />
                                    :<></>}
                                </View>
                                <Text style={{ marginLeft:10 }} theme='h2'>{so.toUpperCase()}</Text>
                            </TouchableOpacity>
                        )
                    })}
                </View>
                    :<></>}
                </View>
            </View>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <View nativeID='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View float style={{ padding:10, borderRadius:8 }}>
                    {icon}
                </View>
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text size={16} theme='h1'>{title}</Text>
                    <Text style={{ marginTop:3 }} size={12} theme='description'>{description}</Text>
                </View>
            </View>
            <View style={{ flex:1 }}>
                <FlatList
                    data={settings}
                    renderItem={renderPreferences}
                    keyExtractor={(item) => item.setting_id.toString()}
                />
            </View>
        </View>
    )
}


export default SettingsManager